import { Toast } from 'cdk-radial';
import styled from 'styled-components';

export const ErrorToast = styled(Toast)`
  max-width: 35rem;
  pointer-events: auto;
`;
